import React from 'react';
import PropTypes from 'prop-types';
import { colors } from "../../styles/theme"
import styles from './region-entity-table.module.scss';
import { CampusIcon, StudentsIcon, StaffIcon, SchoolIcon } from "../../components/icons"
import { humanizeNumber } from '../../helpers/formatters';

const HeaderCell = ({ label, value }) => {
    const iconStyle = { color: colors.qaoPurple, marginTop: 2, height: 24 }
    return (
        <div style={{ height: 45, marginBottom: 20 }}>
            <div style={{ display: 'inline-block', width: 24, height: 40, verticalAlign: 'top' }}>
                <div style={{ display: 'block', width: 24, height: 24, marginBottom: 16 }}>
                    {label.includes('campuses') && <CampusIcon style={iconStyle} />}
                    {label.includes('students') && <StudentsIcon style={iconStyle} />}
                    {label === 'staff (fte)' && <StaffIcon style={iconStyle} />}
                    {label === 'schools' && <SchoolIcon style={iconStyle} />}
                </div>
            </div>
            <div style={{ display: 'inline-block', marginLeft: 18, height: 40 }}>
                <div className={styles.tableHeaderText}>{humanizeNumber(value, 'number', true)}</div>
                <div className={styles.headerCellSubscript}>{label}</div>
            </div>
        </div>
    )
}

HeaderCell.propTypes = {
    label: PropTypes.string,
    value: PropTypes.number,
};

export default HeaderCell;


// WEBPACK FOOTER //
// ./src/components/region-entity-table/header-cell.js